import { ArrowRight, CheckCircle2, QrCode, RadioTower, ShieldCheck } from 'lucide-react';
import { operatorBenefits } from '../content';

export function Hero() {
  return (
    <section id="top" className="hero">
      <div className="hero-background" aria-hidden="true" />
      <div className="hero-inner">
        <div className="hero-copy">
          <p className="eyebrow hero-eyebrow">Beyond4 marketing operations</p>
          <h1>Stop holding your breath before every campaign launch.</h1>
          <p className="hero-lede">
            B4 gives multi-location brands one place to line up the audience, offer, page, QR code, location rules, approvals, and reporting before anything goes live.
          </p>
          <div className="hero-actions">
            <a className="button button-primary" href="/contact">
              <span>Sign up for a demo</span>
              <ArrowRight size={18} />
            </a>
            <a className="button button-secondary" href="/platform">
              See what it replaces
            </a>
          </div>
          <div className="benefit-pills" aria-label="Operator benefits">
            {operatorBenefits.map((benefit) => {
              const Icon = benefit.icon;
              return (
                <span key={benefit.label}>
                  <Icon size={15} />
                  {benefit.label}
                </span>
              );
            })}
          </div>
        </div>
        <div className="hero-visual" aria-label="B4 product workflow preview">
          <div className="mock-window">
            <div className="mock-titlebar">
              <span />
              <span />
              <span />
              <strong>Campaign command center</strong>
            </div>
            <div className="mock-dashboard">
              <div className="mock-main">
                <div className="mock-kicker">Mighty Fine Burgers / all channels</div>
                <h2>Summer QR launch</h2>
                <div className="mock-status-row">
                  <span className="status-green"><CheckCircle2 size={15} /> Ready to publish</span>
                  <span>2 channels</span>
                  <span>5 locations</span>
                </div>
                <div className="mock-progress">
                  <div style={{ width: '74%' }} />
                </div>
                <div className="mock-steps">
                  {['Setup', 'Content', 'Filters', 'Review'].map((step, index) => (
                    <span className={index < 3 ? 'step-active' : ''} key={step}>{step}</span>
                  ))}
                </div>
                <div className="mock-channel-list">
                  <article>
                    <QrCode size={22} />
                    <div>
                      <strong>QR redirect</strong>
                      <p>1,248 scans / 312 signups</p>
                    </div>
                  </article>
                  <article>
                    <RadioTower size={22} />
                    <div>
                      <strong>Landing page</strong>
                      <p>Public URL, embed, and location scope</p>
                    </div>
                  </article>
                </div>
              </div>
              <aside className="mock-side">
                <ShieldCheck size={23} />
                <strong>Launch confidence</strong>
                <p>Know who receives it, where it points, which locations are included, and what success looks like before the first scan or send.</p>
              </aside>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
